export default "__VITE_ASSET__CgVz6x$F__"